import { render } from "./DataProject.vue?vue&type=template&id=0ee3f498&scoped=true"
import script from "./DataProject.vue?vue&type=script&lang=js"
export * from "./DataProject.vue?vue&type=script&lang=js"

import "./DataProject.vue?vue&type=style&index=0&id=0ee3f498&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee3f498"]])

export default __exports__